import { useEffect, useState, useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { toggleDocumentHistoryColumnShort } from '../app/features/blDetails/slices/documentHistorySlice';
import { updateBlDetailsRowColumns } from '../app/features/blDetails/slices/blDetailsTable';
import { useBackNavigation } from './BackNavigation';

interface UseFormNavigationWarningProps {
  isChanged: boolean;
  onConfirm?: () => void;
  isEditable?: boolean;
  inner?: boolean;
}

const WARNING_MESSAGE = 'You have unsaved changes. Are you sure you want to leave this form?';

export const useFormNavigationWarning = ({ 
  isChanged, 
  onConfirm,
  isEditable = true,
  inner = true
}: UseFormNavigationWarningProps) => {
  const [showModal, setShowModal] = useState(false);
  const [pendingNavigation, setPendingNavigation] = useState<string | null>(null);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  // Use inner=true for default behavior, or make configurable if needed
  const onBack = useBackNavigation(inner);

  // Handle browser back/forward, refresh, and close
  // useEffect(() => {
  //   if (!isEditable) return;

  //   const handleBeforeUnload = (e: BeforeUnloadEvent) => {
  //     if (isChanged) {
  //       e.preventDefault();
  //       e.returnValue = WARNING_MESSAGE;
  //       return e.returnValue;
  //     }
  //   };

  //   window.addEventListener('beforeunload', handleBeforeUnload);
  //   return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  // }, [isChanged, isEditable]);

  // // Handle clicks on buttons, links, and navigation elements
  // useEffect(() => {
  //   if (!isEditable) return;

  //   const handleClick = (e: MouseEvent) => {
  //   //   const target = e.target as HTMLElement;
  //   //   console.log("treagetee",target)
  //   //   // Only trigger for navigation elements when form is dirty
  //   //   const isNavigationElement = 
  //   //     target.closest('a[href]') || 
  //   //     //target.closest('button') ||
  //   //   //  target.closest('[role="button"]') ||
  //   //     target.closest('[data-navigate]') ||
  //   //     target.closest('.nav-link') ||
  //   //  //   target.closest('.btn') ||
  //   //    // target.closest('[onclick]') ||
  //   //    /*  target.closest('[type="submit"]') ||
  //   //     target.closest('[type="button"]') || */
  //   //     // Also treat <span> or <div> with class 'cursor-pointer' as navigation
  //   //     ((target.tagName === 'SPAN' || target.tagName === 'DIV') && target.classList.contains('cursor-pointer'));

  //   //   // Don't trigger for form inputs, modals, or when clicking inside the form
  //   //   const isFormElement = 
  //   //     target.closest('input') ||
  //   //     target.closest('textarea') ||
  //   //     target.closest('select') ||
  //   //     target.closest('form') ||
  //   //     target.closest('.modal') ||
  //   //     target.closest('.modal-backdrop');

  //   //   if (isFormElement) {
  //   //     return; // Don't interfere with form interactions
  //   //   }

  //   //   // Only show modal if clicking on navigation element AND form is dirty
  //   //   if (isNavigationElement && isChanged) {
  //   //     e.preventDefault();
  //   //     e.stopPropagation();
  //   //     setShowModal(true);
  //   //     setPendingNavigation(location.pathname);
  //   //   }
  //   };

  //   document.addEventListener('click', handleClick, true); // Use capture phase
  //   return () => document.removeEventListener('click', handleClick, true);
  // }, [isChanged, location.pathname, isEditable]);

  // // Handle tab visibility changes
  // useEffect(() => {
  //   if (!isEditable) return;

  //   const handleVisibilityChange = () => {
  //     if (document.hidden && isChanged) {
  //       setShowModal(true);
  //       setPendingNavigation(location.pathname);
  //     }
  //   };

  //   document.addEventListener('visibilitychange', handleVisibilityChange);
  //   return () => document.removeEventListener('visibilitychange', handleVisibilityChange);
  // }, [isChanged, location.pathname, isEditable]);

  const handleNavigation = useCallback((to: string) => {
    // if (isEditable && isChanged) {
    //   setShowModal(true);
    //   setPendingNavigation(to);
    // } else {
    //   navigate(to);
    // }
    navigate(to)
  }, [isChanged, isEditable, navigate]);

  const handleConfirm = useCallback(() => {
    setShowModal(false);
    if (onConfirm) {
      onConfirm();
    }
    // Use the same close method as PickUpInstruction
    dispatch(toggleDocumentHistoryColumnShort(false));
    dispatch(
      updateBlDetailsRowColumns({
        mainTableClass: 'col-lg-2',
        documentMainViewClass: 'col-lg-10',
        documentHistoryClass: 'col-lg-12',
        outletClass: 'd-none',
      })
    );
    setPendingNavigation(null);
  }, [onConfirm, dispatch]);

  const handleCancel = useCallback(() => {
    setShowModal(false);
    setPendingNavigation(null);
  }, []);

  const handleBack = useCallback(() => {
    // if (isEditable && isChanged) {
    //   setShowModal(true);
    //   setPendingNavigation('back');
    // } else {
    //   onBack();
    // }
    onBack()
  }, [isChanged, isEditable, onBack]);
// useEffect(() => {
//   if (!isChanged && showModal) {
//     setShowModal(false);
//     setPendingNavigation(null);
//   }
// }, [isChanged, showModal]);
// useEffect(() => {
  
//   return () => {
//     setShowModal(false);
//     setPendingNavigation(null);
//   };
// }, []);
  return {
    showModal,
    handleNavigation,
    handleConfirm,
    handleCancel,
    handleBack,
    warningMessage: WARNING_MESSAGE
  };
}; 